// eslint-disable-next-line no-restricted-imports
import {
  LegalClientLegalHeadForLegalClientFragment,
  Query_LegalClientController_GetList_AllOf_1_List_Items_LegalHeads_Items_Status,
} from 'api/generated/graphql';
import { parseCountryEntity } from 'api/helpers/parseCountryEntity';
import { LegalClientLegalHeadItemEntity } from 'api/types/entity/legal/legalClientLegalHeadItemEntity';

export const parseLegalClientLegalHeadItemEntity = (
  data: LegalClientLegalHeadForLegalClientFragment
): LegalClientLegalHeadItemEntity => ({
  id: data.id,
  name: data.fullName ?? '',
  createdAt: new Date(data.createdAt),
  registrationCountry: data.legalAddress
    ? parseCountryEntity(data.legalAddress.country)
    : undefined,
  residentialCountry: data.actualAddress
    ? parseCountryEntity(data.actualAddress.country)
    : undefined,
  archived:
    data.status ===
    Query_LegalClientController_GetList_AllOf_1_List_Items_LegalHeads_Items_Status.Archived,

  positionInCompany: data.positionInCompany
    ? {
        expirationDate: data.positionInCompany.expirationDate
          ? new Date(data.positionInCompany.expirationDate)
          : undefined,
        position: data.positionInCompany.positionInCompany,
      }
    : undefined,
});
